import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskRedirectRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-redirect',
	path: '/jira/servicedesk/projects/:projectKey/settings',
};
